module.exports = __webpack_public_path__ + "static/img/default.40358e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/system/assets/default.png
// module id = CXR1
// module chunks = 3